import { BasketId } from './../../components/Basket/Basket.types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import adserver from 'services/adserver';
import { withErrorHandling } from 'store/wrappers';
import { REDUCER_KEY } from './orders.consts';
import { OrderParams, UpdateParams, OrderBodyParams } from './orders.types';
import { normalizeDateFromApiWithoutTimeCorrection } from 'helpers/datetimeHelpers';

function normalizeApiReponse(data: OrderParams) {
  const parseTimestamp = (timestamp: any) => {
    if (typeof timestamp === 'number' && timestamp.toString().includes('.')) {
      // Rozdzielenie sekund i ułamków sekund
      const seconds = Math.floor(timestamp); // Część całkowita (sekundy)
      const milliseconds = Math.round((timestamp - seconds) * 1000); // Ułamki sekund na milisekundy
      return new Date(seconds * 1000 + milliseconds); // Tworzenie daty
    }
    return timestamp; // Jeśli nie jest w formacie z ułamkami, zwróć oryginalną wartość
  };

  const currentUpdate = {
    ...data.currentUpdate,
    uploadDate: normalizeDateFromApiWithoutTimeCorrection(
      parseTimestamp(data.currentUpdate.uploadDate),
    ),
  };
  const updates = data.updates.map((update: UpdateParams) => ({
    ...update,
    uploadDate: normalizeDateFromApiWithoutTimeCorrection(
      parseTimestamp(update.uploadDate),
    ),
  }));
  return {
    ...data,
    currentUpdate,
    updates,
  };
}

/* function normalizeApiRequest(data: OrderParams) {
  const currentUpdate = {
    ...data.currentUpdate,
    uploadDate: normalizeDateForApi(data.currentUpdate.uploadDate),
  };
  const updates = data.updates.map((update: UpdateParams) => ({
    ...update,
    uploadDate: normalizeDateForApi(update.uploadDate),
  }));
  return {
    ...data,
    currentUpdate,
    updates,
  };
} */

export const fetchAllOrders = createAsyncThunk(
  REDUCER_KEY + '/fetchAllOrders',
  withErrorHandling(async ({ basketId }: { basketId: number }) => {
    const response = await adserver({
      url: `/basket/${basketId}/orders`,
      headers: {},
    });
    return response.data.map((order: OrderParams) => ({
      ...normalizeApiReponse(order),
      basketId,
    }));
  }),
);

export const fetchOrderById = createAsyncThunk(
  REDUCER_KEY + '/get',
  withErrorHandling(
    async ({ basketId, orderId }: { basketId: number; orderId: number }) => {
      const response = await adserver({
        url: `/basket/${basketId}/orders/${orderId}`,
        headers: {},
      });

      return { ...normalizeApiReponse(response.data), basketId };
    },
  ),
);

export const create = createAsyncThunk(
  REDUCER_KEY + '/create',
  withErrorHandling(async (basketId: number) => {
    const response = await adserver({
      url: `/basket/${basketId}/orders/create`,
      method: 'POST',
      headers: {},
    });
    return { ...normalizeApiReponse(response.data), basketId };
  }),
);

export const createFinalized = createAsyncThunk(
  REDUCER_KEY + '/createFinalized',
  withErrorHandling(
    async ({ basketId, ...data }: { basketId: number } & any) => {
      const response = await adserver({
        url: `/basket/${basketId}/orders/create/finalized`,
        method: 'POST',
        headers: {},
        data,
      });
      return { ...normalizeApiReponse(response.data), basketId };
    },
  ),
);

export const accept = createAsyncThunk(
  REDUCER_KEY + '/accept',
  withErrorHandling(async (order: OrderParams) => {
    const response = await adserver({
      url: `/basket/${order.basketId}/orders/${order.id}/accept`,
      method: 'POST',
      headers: {},
    });
    return response.data;
  }),
);

export const rectify = createAsyncThunk(
  REDUCER_KEY + '/rectify',
  withErrorHandling(
    async (order: {
      basketId: BasketId;
      id: number;
      commentary: string;
      value: number;
    }) => {
      const data = { commentary: order.commentary };
      const response = await adserver({
        url: `/basket/${order.basketId}/orders/${order.id}/rectify`,
        method: 'POST',
        headers: {},
        data,
      });
      return response.data;
    },
  ),
);

export const cancel = createAsyncThunk(
  REDUCER_KEY + '/cancel',
  withErrorHandling(async (order: OrderParams) => {
    const response = await adserver({
      url: `/basket/${order.basketId}/orders/${order.id}/cancel`,
      method: 'POST',
      headers: {},
    });
    return response.data;
  }),
);

export const submit = createAsyncThunk(
  REDUCER_KEY + '/update',
  withErrorHandling(
    async (order: OrderBodyParams & { basketId: number; id: number }) => {
      const response = await adserver({
        url: `/basket/${order.basketId}/orders/${order.id}/submit`,
        method: 'POST',
        headers: {},
        data: order,
      });
      return response.data;
    },
  ),
);

export const removeAllOrders = (): { type: string } => ({
  type: REDUCER_KEY + '/removeAll',
});
